export default __webpack_public_path__ + "static/media/ray4.99ffa9a0.webp";